// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MechanicTier_mechanic-tier__q8qNa {
  padding: 0.4rem 0.6rem;
  border-radius: 6px;
  font-size: var(--text-xs);
  font-weight: 700;
}

.MechanicTier_mechanic-tier--gold__FTl5h {
  border: 1px solid var(--gold-dark);
  color: var(--gold-dark);
  background-color: var(--gold-light);
}

.MechanicTier_mechanic-tier--silver__L1\\+ie {
  border: 1px solid #000;
  color: #000;
  background-color: #000;
}

.MechanicTier_mechanic-tier--bronze__ceW9- {
  border: 1px solid #000;
  color: #000;
  background-color: #000;
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/DashboardHeader/MechanicMenu/MechanicTier/MechanicTier.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB","sourcesContent":[".mechanic-tier {\n  padding: 0.4rem 0.6rem;\n  border-radius: 6px;\n  font-size: var(--text-xs);\n  font-weight: 700;\n}\n\n.mechanic-tier--gold {\n  border: 1px solid var(--gold-dark);\n  color: var(--gold-dark);\n  background-color: var(--gold-light);\n}\n\n.mechanic-tier--silver {\n  border: 1px solid #000;\n  color: #000;\n  background-color: #000;\n}\n\n.mechanic-tier--bronze {\n  border: 1px solid #000;\n  color: #000;\n  background-color: #000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mechanic-tier": `MechanicTier_mechanic-tier__q8qNa`,
	"mechanic-tier--gold": `MechanicTier_mechanic-tier--gold__FTl5h`,
	"mechanic-tier--silver": `MechanicTier_mechanic-tier--silver__L1+ie`,
	"mechanic-tier--bronze": `MechanicTier_mechanic-tier--bronze__ceW9-`
};
export default ___CSS_LOADER_EXPORT___;
